import { render, staticRenderFns } from "./WinnersList.vue?vue&type=template&id=55b5ea42&scoped=true"
import script from "./WinnersList.vue?vue&type=script&lang=js"
export * from "./WinnersList.vue?vue&type=script&lang=js"
import style0 from "./WinnersList.vue?vue&type=style&index=0&id=55b5ea42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b5ea42",
  null
  
)

export default component.exports